module.exports = __webpack_public_path__ + "img/ttddonis.a696928e.png";